// core
import React from "react";

// components
import Icon from "../../Icon/Icon";

// styles
import styles from "./ModalHeader.module.scss";
import cx from "classnames";

interface IModalHeader {
    title?: string;
    className?: string;
    onClose?: () => void;
}

const ModalHeader: React.FC<IModalHeader> = ({ title, className, onClose, children }) => {
    return (
        <div
            className={cx(
                styles["container"],
                "layout-flex-row--justify-spaced",
                "layout-flex-row--centered",
                {
                    [className]: !!className
                }
            )}>
            <h3
                className={cx(
                    styles["title"],
                    "text-font-size-modal",
                    "text-primary",
                    "text-zero-margin",
                    "layout-flex-s"
                )}>
                {title}
                {children}
            </h3>

            {onClose && (
                <div className={styles["header-close"]} onClick={onClose}>
                    <div className={styles["icon-container"]}>
                        <Icon className={styles["icon"]} id="CloseModal" />
                    </div>
                </div>
            )}
        </div>
    );
};

export default ModalHeader;
